// extracted by mini-css-extract-plugin
module.exports = {"dp3-crowdfunding":"CrowdFunding_dp3-crowdfunding__rd4rm"};